import { createRouter, createWebHashHistory } from 'vue-router'

import routes from './routes'
import moment from 'moment'
import i18n from '@/typescript/servicos/i18n/i18n.servico'
import { obterDiaInicioFolha } from '@/integracoes/src-next/catalogos/periodo-folha-empregado'
import store from 'src/store'
import { obterPeriodoDeFolhaDoEmpregado } from 'src/utils/formatadoras/formatadoras'
import { realizeSSOLogin, startRefreshTokensWorkerForSSO } from './sso'
import { retrieveCurrentAuthenticatedUserAmplify, verifyAuthAndLoadUserAndStyles } from './auth'
import { formbricksGlobal } from 'src/main'
import { inicializarKeycloakRefreshTokenWorker } from 'src/typescript/servicos/keycloak/renovarToken.servico'
import { enviarEventoPosthog } from 'src/typescript/servicos/posthog/posthog.servico'
import { Notification } from 'src/common/uiv/notification'
import { OPERADORES_DE_VALIDACAO, TIPO_CONDICAO } from 'src/core/modulos/index.ts'
import { empresaUsaApisRefatoracaoFolha } from '../components/Sheets/Timesheet/utils'
import { criarEsperaPelosRequisitos, requisitosAtendidos } from './esperaPelosRequisitos'
import { ACOES_CONTROLE_DE_ESTACOES, MODULOS_CONTROLE_DE_ESTACOES, possuiAlgumaLeituraControleDeEstacoes, possuiPermissaoControleDeEstacoes } from '@/components/ControleDeEstacoes/permissoes'
import { podeAcessarConexoesMcp } from 'src/typescript/modulos/governanca/ConexoesMcp/dominio/conexoesMcp'
import { inicializarNavegacaoWorkspace } from 'src/typescript/servicos/workspace/navegacaoWorkspace.servico'
import { FiltradorDeErros } from 'src/erros'
import { aplicarMarcaWhitelabel } from 'src/typescript/servicos/marca/marcaWhitelabel.servico'

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

inicializarNavegacaoWorkspace(router, {
  capturarErro: erro => FiltradorDeErros.capturarErro(erro)
})

// 1º Lets check if we need to sign in using sso. After this step, the next beforeEach will
// se that user is already sign in and use this user
// we use this variable to unregister this beforeeach. Its to ensure that is called only once
export const unregisterSSOLogin = router.beforeEach(realizeSSOLogin)

// 2º its not a router event each, its a pure function. it will only be callend when pages is lodaded
retrieveCurrentAuthenticatedUserAmplify()

// 3º Load current user infos from back, and verify if users still logged in, if is not the case
// the appropriate logout method will be applied
router.beforeEach(verifyAuthAndLoadUserAndStyles)

// 5º Set the title of current page
router.afterEach(function (to, from) {
  const titulo = to.meta.title || 'Pontotel'
  document.title = aplicarMarcaWhitelabel(titulo, store.state)

  if (to.meta.title) {
    if (to.meta.title !== from.meta.title) {
      enviarEventoPosthog('$pageview', {
        $previous_page_name: from.meta.title
      });
    }
  }
})

/**
 * Se estiver indo para a folha e usa as novas apis da folha, não é considerado startDate e endDate,
 * somenteu uma data e o back calcula o seu periodo fechado automaticamente.
 * portanto, se usar as novas apis da folha, devemos remover o endDate da rota.
 */
router.beforeEach(function (to, from, next) {
  if (to.name !== 'timesheet') {
    next()
    return
  }

  if (empresaUsaApisRefatoracaoFolha() && to.params.endDate) {
    const isId = /^[0-9a-fA-F]{15,}$/.test(to.params.endDate)

    if (isId) {
      to.params.id = to.params.endDate
      delete to.params.endDate
      next()
      return
    }

    const params = { ...to.params }
    delete params.endDate
    next({ name: to.name, params, replace: true })
    return
  }

  next()
})

window.router = router

// 5º If is logged with SSO we must start the worker
router.afterEach(startRefreshTokensWorkerForSSO)
router.afterEach(inicializarKeycloakRefreshTokenWorker)
router.afterEach(() => {
  if (formbricksGlobal.verificarFormbricksEstaAtivo() && formbricksGlobal.verificarUsuarioEmSessaoAtiva()) {
    formbricksGlobal.registrarMudancaDeRota()
  }
})
router.queueEmployeesInTimesheet = async function (employeesIds, baseDate) {
  // use this function when you want to go to timesheet with a queue of employees

  await store.dispatch('common/employees/fetchItems')
  const employees = store.state.common.employees.items.filter(i => employeesIds.includes(i.id))

  if (employees.length === 0) {
    throw new Error('queueEmployeesInTimesheet received invalid params')
  }

  store.commit('timesheet/header/resetState')
  store.commit('sheet/resetState')
  store.commit('timesheet/header/queueEmployees', employees)

  router.push({
    name: 'timesheet',
    params: {
      type: 'queue',
      startDate: moment(baseDate).format('YYYY-MM-DD'),
      endDate: moment(baseDate).format('YYYY-MM-DD'),
      id: employees[0].id
    }
  })
}

router.goToTimesheet = function (baseDate, employee = null, company = null, blank = false) {
  if (!employee && !company) {
    throw new Error('goToTimesheet router method received no parameters')
  }
  const diaInicioFolha = employee ? obterDiaInicioFolha(employee.closingDate) : null
  if (employee && diaInicioFolha === null) {
    throw new Error(i18n.global.t('srcNext.estruturaDePontoDaEmpresa.catalogoEmpregado.erroPeriodoEmpregado'))
  }

  let startDate, endDate

  if (employee) {
    const period = obterPeriodoDeFolhaDoEmpregado(baseDate, diaInicioFolha)
    startDate = period.startDate
    endDate = period.endDate
  } else {
    const date = moment.isMoment(baseDate) ? baseDate : moment(baseDate)
    startDate = date
    endDate = date
  }

  const params = {
    name: 'timesheet',
    params: {
      type: employee ? 'employee' : 'work-place',
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      id: employee ? employee.id : company.id
    }
  }

  if (blank) {
    window.open(router.resolve(params).href, '_blank')
  } else {
    router.push(params)
  }
}

export const validarRequisitos = (metaRequisitos) => {
  const modulosDoSistemaStore = store.state.modulosEFuncionalidades.modulos
  const funcionalidadesDoSistemaStore = store.state.modulosEFuncionalidades.funcionalidades

  const temModulo = (item) => !!modulosDoSistemaStore[item];

  const temFuncionalidade = (item) => {
    const funcionalidade = funcionalidadesDoSistemaStore[item];
    return funcionalidade && funcionalidade.enabled;
  };

  const verificarCondicao = (metaRequisitosCondicao) => {
    if (!metaRequisitosCondicao.modulo || metaRequisitosCondicao.modulo.length === 0) {
      return false; // Ignora condições vazias
    }

    const operador = metaRequisitos.operador;
    const tipo = metaRequisitosCondicao.tipo;
    const listaModulosFuncionalidades = metaRequisitosCondicao.modulo;

    if (tipo === TIPO_CONDICAO.MODULO) {
      if (operador === OPERADORES_DE_VALIDACAO.E) {
        return listaModulosFuncionalidades.every(temModulo)
      } else {
        return listaModulosFuncionalidades.some(temModulo)
      }
    }

    if (tipo === TIPO_CONDICAO.FUNCIONALIDADE) {
      if (operador === OPERADORES_DE_VALIDACAO.E) {
        return listaModulosFuncionalidades.every(temFuncionalidade)
      } else {
        return listaModulosFuncionalidades.some(temFuncionalidade)
      }
    }

    if (tipo === TIPO_CONDICAO.MODULO_E_FUNCIONALIDADE) {
      const modulosNaLista = listaModulosFuncionalidades.filter(item => modulosDoSistemaStore.hasOwnProperty(item));
      const funcionalidadesNaLista = listaModulosFuncionalidades.filter(item => funcionalidadesDoSistemaStore.hasOwnProperty(item));

      if (operador === OPERADORES_DE_VALIDACAO.E) {
        return modulosNaLista.every(temModulo) && funcionalidadesNaLista.every(temFuncionalidade);
      } else {
        return modulosNaLista.some(temModulo) || funcionalidadesNaLista.some(temFuncionalidade);
      }
    }

    return false
  }

  const { operador, condicoes } = metaRequisitos

  switch (operador) {
    case OPERADORES_DE_VALIDACAO.E:
      return condicoes.every(verificarCondicao)
    case OPERADORES_DE_VALIDACAO.OU:
      return condicoes.some(verificarCondicao)
    default:
      return condicoes.some(verificarCondicao)
  }
}

/**
 * As flags do tenant chegam depois do boot. Um deep-link que aterrissa antes
 * delas seria reprovado pelos valores padrão — ver `esperaPelosRequisitos`.
 *
 * O store entra por thunk: este módulo é avaliado no meio do ciclo de imports
 * que passa por `src/store`, e ler `store.subscribe` aqui pegaria `undefined`.
 */
const esperaPelosRequisitos = criarEsperaPelosRequisitos(() => store)

router.beforeEach((to, _, next) => {
  if (to.meta?.requerPermissaoControleDeEstacoes) {
    const roles = store.getters.getUserInfo?.roles || []
    const podeAcessarDetalhe = to.name !== 'controle-de-estacoes.station-detail' || possuiPermissaoControleDeEstacoes(roles, MODULOS_CONTROLE_DE_ESTACOES.ESTACOES, ACOES_CONTROLE_DE_ESTACOES.VER)
    if (!possuiAlgumaLeituraControleDeEstacoes(roles) || !podeAcessarDetalhe) {
      Notification.notify({
        type: 'info',
        content: 'Você não tem permissão para acessar essa página.',
      })
      next({ name: 'home' })
      return
    }
  }
  next()
})

router.beforeEach((to, _, next) => {
  if (to.meta?.requerAcessoConexoesMcp && !podeAcessarConexoesMcp(store.getters.getUserInfo)) {
    Notification.notify({
      type: 'info',
      content: i18n.global.t('conexoesMcp.erros.semPermissao'),
    })
    next({ name: 'home' })
    return
  }
  next()
})

router.beforeEach(async (to, _, next) => {
  // A primeira navegação da sessão acontece antes de o Flagsmith responder, e
  // é ela que deixa a escuta de pé. Idempotente nas seguintes.
  esperaPelosRequisitos.garantirEscuta()

  const requisitosDeAcesso = to.meta?.requisitosDeAcesso

  if (!requisitosDeAcesso) {
    next()
    return
  }

  const redirecionarHomeComAviso = () => {
    Notification.notify({
      type: 'info',
      content: 'Você não possui o módulo necessário para acessar essa página.',
    })

    if (to.name === 'home') {
      next(false)
      return
    }

    next({ name: 'home' })
  }

  const atendidos = await requisitosAtendidos(
    () => validarRequisitos(requisitosDeAcesso),
    esperaPelosRequisitos
  )

  atendidos ? next() : redirecionarHomeComAviso()
})

export default router
